import React from 'react';
import { FlameIcon } from 'lucide-react';
import { problems } from '../data/services';
const ALTAR_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/973c4b19-8165-4f9b-a99f-79dbace66f58.jpg';
export function GuaranteeSection() {
  return <section className="relative isolate overflow-hidden px-5 py-16 lg:px-8 lg:py-24" data-id="element-70" data-mp="9wfr0ih8sskk">
      <img src={ALTAR_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover" data-id="element-71" data-mp="eur20wj9x94d" />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-ink/85" data-id="element-72" data-mp="ntcfwedsvzyt" />

      <div className="mx-auto max-w-4xl text-center" data-id="element-73" data-mp="skkq3cmyfpd1">
        <FlameIcon className="mx-auto h-8 w-8 text-gold" aria-hidden="true" data-id="element-74" data-mp="sn6vb5mdhss3" />
        <h2 className="mt-5 font-display text-3xl uppercase tracking-[0.1em] text-gold-soft sm:text-4xl" data-id="element-75" data-mp="xjfdyszs4440">
          ¡Trabajo garantizado!
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-76" data-mp="17hlhtg55bkbi">
          Yo soy el Maestro que te ofrece y te enseña cómo atraer la suerte a tu
          vida: salud, amor, suerte y éxito. Trabajo con corazón, efectividad,
          responsabilidad y experiencia.
        </p>

        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-2.5" data-id="element-77" data-mp="1vt7pmq26f1gm">
          {problems.map(problem => <li key={problem} className="rounded-full border border-gold/30 bg-ink/70 px-4 py-2 text-sm font-medium text-gold-soft" data-id="element-78" data-mp="1rth3x0ribbiy">
              {problem}
            </li>)}
        </ul>

        <p className="mt-10 text-base text-white/70" data-id="element-79" data-mp="2jlo9951kb1i1">
          Déjame saber cómo puedo ayudarte a cortar o eliminar todo lo que
          estorba tu camino.
        </p>
      </div>
    </section>;
}